export default __webpack_public_path__ + "static/media/Mailbox.074061f1.svg";